import React from "react";
import {
  ButtonWithAction,
  Cluster,
  Box,
  Text,
  ChevronIcon,
} from "@thecb/components";

import { ACTIVE_PRIMARY, BACKGROUND_DIM } from "@/constants/colors";
import { noop } from "@/util/common";

const PAGING_SPACE = 2; // how many pages we want to have before/after delimiter
const PAGING_INIT_SPACE = 3; // first delimiter should appear after 3 pages

const PrevNextButton = ({ action, type }) => (
  <Box padding="0 10px 0" minHeight="40px" extraStyles="max-height: 40px;">
    <ButtonWithAction
      action={action}
      contentOverride
      dataQa={type}
      extraStyles={`
        min-width: 40px;
        min-height: 100%;
        max-height: 40px;
        padding: 6px;
        border-radius: 3px;
        margin: 0rem;
      `}
    >
      <Box padding="0" extraStyles={type === "prev" && "transform: scaleX(-1)"}>
        <ChevronIcon variant="darkMode" iconFill="white" />
      </Box>
    </ButtonWithAction>
  </Box>
);

export const getPagesPanel = (page, pagesCount) => {
  if (!pagesCount || pagesCount <= 1) {
    return [];
  }
  const lastPageNumber = pagesCount;
  const space = page === 1 ? PAGING_INIT_SPACE : PAGING_SPACE;
  const pages = [{ index: 1, isButton: true }];
  if (page > space + 1) {
    pages.push({ isDelimiter: true });
  }
  for (
    let j = Math.max(1, page - space) + 1;
    j < Math.min(lastPageNumber, page + space);
    j++
  ) {
    pages.push({ index: j, isButton: true });
  }
  if (page < lastPageNumber - space) {
    pages.push({ isDelimiter: true });
  }
  pages.push({ index: lastPageNumber, isButton: true });
  const activePage = pages.find((p) => p.index === page);
  if (activePage) {
    activePage.active = true;
  }
  return pages;
};

const Pagination = ({
  pagePrevious,
  pageNext,
  setCurrentPage,
  currentPage,
  pageCount,
}) => (
  <Cluster justify="center" childGap="10px">
    {currentPage > 1 && <PrevNextButton type="prev" action={pagePrevious} />}
    {getPagesPanel(currentPage, pageCount).map((item, index) =>
      item.isButton ? (
        <Box
          key={index}
          padding="0"
          border={item.active && `2px solid ${ACTIVE_PRIMARY}`}
          borderRadius={item.active && "3px"}
          extraStyles={`max-height: 40px; ${item.active && `pointer-events: none;`}`}
        >
          <ButtonWithAction
            variant="ghost"
            key={item.index}
            text={item.index}
            action={
              !item.active ? () => setCurrentPage({ pageNumber: item.index }) : noop
            }
            textExtraStyles={`font-size: 17px; font-weight: 900;`}
            extraStyles={`
              min-width: 40px; min-height: 100%; padding: 0; margin: 0rem;
              &:hover, &:focus {
                text-decoration: none;
                > * > span {
                  text-decoration: none;
                }
              }
            }
            &:hover { ${
              item.active
                ? "cursor: default; pointer-events: none;"
                : `background-color: ${BACKGROUND_DIM}`
            } }
            `}
            dataQa={index}
          >
            {item.index}
          </ButtonWithAction>
        </Box>
      ) : (
        <Box padding="0 10px" key={index}>
          <Cluster justify="flex-end">
            <Text key={index} variant="pXL" weight="900" color={ACTIVE_PRIMARY}>
              {"..."}
            </Text>
          </Cluster>
        </Box>
      )
    )}
    {currentPage < pageCount && <PrevNextButton type="next" action={pageNext} />}
  </Cluster>
);

export default Pagination;
